import { Box, Flex, Text } from '@chakra-ui/layout';

const Label = ({ text, color }: any) => (
    <Flex alignItems="center">
        <Box h="12px" w="12px" bg={color} mr="8px" borderRadius="2px" />
        <Text fontSize="sm" fontWeight="500" color="gray.500">
            {text}
        </Text>
    </Flex>
);

export default Label;
